module.exports = __webpack_public_path__ + "img/unity-logo.80de313e.png";